import React from "react";
import PropTypes from "prop-types";
import { useDispatch } from "react-redux";
import { InputItem } from "../../../../components/forms/FormItems";
import { DatePickerItem } from "../../../../components/forms/FormItems";
import {
  createTableItem,
  updateTableItem,
} from "../../../settings/settingsSlice";
import { useSelector } from "react-redux";
import AddEntityForm from "../../../../components/templates/AddEntityForm";
import { MetaDataSelect } from "../../../../components/forms/AutoCompleteFormItem";
import CheckBoxItem from "../../../../components/forms/CheckBoxItem";

const NewHolidayDay = (props) => {
  const { hide, addText, getData, record } = props;
  const dispatch = useDispatch();
  const loading = useSelector(
    (state) => state.pendingActions["systemTable/create_item"]
  );

  const onFinish = async (values) => {
    const params = {
      source: "salary/holidays",
      record: record ? { ...values, id: record.id } : values,
    };
    const action = await dispatch(
      record ? updateTableItem(params) : createTableItem(params)
    );
    if (!action.error) {
      hide();
      getData();
    }
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const onDecline = () => {
    hide();
  };

  const items = [
    {
      name: "religion_id",
      required: true,
      comp: (
        <MetaDataSelect
          name="religion_id"
          category="holiday"
          metadataName={"religions"}
          required={true}
        />
      ),
    },
    {
      name: "name",
      required: true,
      comp: <InputItem name="name" category="holiday" required={true} />,
    },
    {
      name: "date",
      required: true,
      comp: (
        <DatePickerItem
          name="date"
          category="holiday"
          required={true}
          picker="day"
          format={"DD/MM/YYYY"}
        />
      ),
    },
    {
      name: "holiday_evening",
      comp: (
        <CheckBoxItem
          showLabel={true}
          name="holiday_evening"
          category="holiday"
        />
      ),
    },
    {
      name: "election_day",
      comp: (
        <CheckBoxItem showLabel={true} name="election_day" category="holiday" />
      ),
    },
  ];

  const formLayout = {
    labelCol: { span: 8 },
    wrapperCol: { span: 10 },
  };

  return (
    <AddEntityForm
      resource="organization.settings"
      action="editor"
      items={items}
      activeEntity={record}
      onFinish={onFinish}
      onFinishFailed={onFinishFailed}
      onDecline={onDecline}
      saveLoading={loading}
      addText={addText}
      mode={record ? "edit" : "new"}
      formLayout={formLayout}
      padding={"0 50px"}
    />
  );
};

NewHolidayDay.propTypes = {
  hide: PropTypes.func,
  addText: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
};

export default NewHolidayDay;
